import React from 'react';
import { FaLinkedin } from 'react-icons/fa';
import { BsFillPersonVcardFill } from 'react-icons/bs';
import './CreditsPage.css';

const members = [
  {
    role: 'UI / UX Designer',
    name: 'Katrina Fu',
    linkedin: 'https://www.linkedin.com/in/katrina-fu-87a5851b2/',
    gender: 'female'
  },
  {
    role: 'Project Leader & Full-Stack Developer',
    name: 'Weng Chong (Billy) Lao',
    linkedin: 'https://www.linkedin.com/in/wengchong-lao/',
    gender: 'male'
  },
  {
    role: 'Full-Stack Developer',
    name: 'Fanghui Zhao',
    linkedin: 'https://www.linkedin.com/in/fanghui-zhao?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    gender: 'female'
  }
];


const CreditsPage = () => (
  <section className="credits-page fade-in-up">
    <div className="container-small">
      <h1 className="credits-heading">Meet the Makers</h1>
      <p className="credits-intro">A heartfelt thank-you to the small but mighty team behind this website.</p>

      <div className="credits-grid">
        {members.map(member => (
          <a
            key={member.name}
            href={member.linkedin}
            target="_blank"
            rel="noreferrer"
            className="credit-card"
          >
            <BsFillPersonVcardFill className="avatar-icon" aria-label="profile" />
            <h2 className="credit-name">
              {member.name}
            </h2>
            <p className="credit-role">{member.role}</p>
            <FaLinkedin className="linkedin-icon" />
          </a>
        ))}
      </div>
    </div>
  </section>
);



export default CreditsPage;